import axios from 'axios';
import { baseUrl } from '../hooks/useEndpoints';

/**
 * Endpoints Microcycle Templates — Programmazione Campo.
 * Spec: LEOPART_ProgrammazioneCampo_Spec_v1.1.1.md (Sez 15, 17 righe 1967-1972).
 */

export type MicrocycleScope = 'SYSTEM' | 'TEAM' | 'PERSONAL';
export type MicrocycleVisibility = 'PRIVATE' | 'CLUB' | 'COMMUNITY';

export interface IMicrocycleDaySuggestion {
  blockType: 'sequential' | 'parallel' | 'rotation' | 'break' | 'physical';
  exerciseTags?: string[];
  durationRange?: { min: number; max: number };
}

export interface IMicrocycleDay {
  dayIndex: number;
  mdPosition?: string;
  sessionType?: string;
  targetCE?: { min: number; max: number };
  targetIPS?: { min: number; max: number };
  targetCLS?: { min: number; max: number };
  suggestedBlocks?: IMicrocycleDaySuggestion[];
}

export interface IMicrocycleTemplate {
  _id: string;
  entityId?: string;
  teamId?: string;
  createdBy?: string;
  name: string;
  description?: string;
  sport: string;
  category?: 'pro' | 'amateur' | 'youth';
  mdPattern?: string;
  scope: MicrocycleScope;
  visibility: MicrocycleVisibility;
  isGlobalTemplate?: boolean;
  structure: IMicrocycleDay[];
  usageCount?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface ICreateMicrocycleTemplateBody {
  name: string;
  description?: string;
  sport: string;
  category?: 'pro' | 'amateur' | 'youth';
  mdPattern?: string;
  scope: MicrocycleScope;
  visibility: MicrocycleVisibility;
  structure: IMicrocycleDay[];
}

export const microcycleTemplatesEndpoints = {
  list: (params?: { scope?: MicrocycleScope; sport?: string }) =>
    axios.get<IMicrocycleTemplate[]>(`${baseUrl}/microcycle-templates`, {
      params,
    }),

  get: (id: string) =>
    axios.get<IMicrocycleTemplate>(`${baseUrl}/microcycle-templates/${id}`),

  create: (body: ICreateMicrocycleTemplateBody) =>
    axios.post<IMicrocycleTemplate>(
      `${baseUrl}/microcycle-templates`,
      body,
    ),

  update: (id: string, body: Partial<ICreateMicrocycleTemplateBody>) =>
    axios.patch<IMicrocycleTemplate>(
      `${baseUrl}/microcycle-templates/${id}`,
      body,
    ),

  delete: (id: string) =>
    axios.delete<{ ok: true }>(`${baseUrl}/microcycle-templates/${id}`),
};
